import React from 'react';
import { Button } from '../ui/button';
import { AlertCircle, Sparkles, X } from 'lucide-react';
interface CreditWarningModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  creditsNeeded: number;
  estimatedTotal: number;
}
export function CreditWarningModal({
  isOpen,
  onClose,
  onConfirm,
  creditsNeeded,
  estimatedTotal
}: CreditWarningModalProps) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-1273">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} data-id="element-1274" />

      {/* Modal */}
      <div className="relative bg-card border border-border rounded-xl shadow-lg max-w-md w-full p-6 animate-in fade-in zoom-in duration-200" data-id="element-1275">
        {/* Close button */}
        <button onClick={onClose} className="absolute top-4 right-4 text-muted-foreground hover:text-foreground transition-colors" data-id="element-1276">
          <X size={20} data-id="element-1277" />
        </button>

        {/* Header */}
        <div className="flex items-center gap-3 mb-4" data-id="element-1278">
          <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center" data-id="element-1279">
            <Sparkles size={24} className="text-primary" data-id="element-1280" />
          </div>
          <div data-id="element-1281">
            <h2 className="text-xl font-semibold" data-id="element-1282">Confirm Comment Fetch</h2>
            <p className="text-sm text-muted-foreground" data-id="element-1283">
              Review before proceeding
            </p>
          </div>
        </div>

        {/* Info */}
        <div className="space-y-3 mb-6" data-id="element-1284">
          <div className="p-4 bg-secondary/30 rounded-lg" data-id="element-1285">
            <div className="flex items-center justify-between mb-2" data-id="element-1286">
              <span className="text-sm text-muted-foreground" data-id="element-1287">
                Total Comments
              </span>
              <span className="text-lg font-semibold" data-id="element-1288">
                {estimatedTotal.toLocaleString()}
              </span>
            </div>
            <div className="flex items-center justify-between" data-id="element-1289">
              <span className="text-sm text-muted-foreground" data-id="element-1290">
                Credits Required
              </span>
              <span className="text-lg font-semibold text-primary" data-id="element-1291">
                {creditsNeeded}
              </span>
            </div>
          </div>

          <div className="p-3 bg-blue-500/10 border border-blue-500/20 rounded-lg" data-id="element-1292">
            <div className="flex items-start gap-2" data-id="element-1293">
              <AlertCircle size={16} className="text-blue-600 dark:text-blue-400 mt-0.5 flex-shrink-0" data-id="element-1294" />
              <div className="text-xs text-blue-600 dark:text-blue-400" data-id="element-1295">
                <p className="font-medium mb-1" data-id="element-1296">How credits work:</p>
                <ul className="space-y-1 list-disc list-inside" data-id="element-1297">
                  <li data-id="element-1298">1 credit per 100 comments</li>
                  <li data-id="element-1299">Charged based on actual comments fetched</li>
                  <li data-id="element-1300">Partial refund if fetch fails</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Actions */}
        <div className="flex gap-3" data-id="element-1301">
          <Button onClick={onClose} variant="outline" className="flex-1" size="sm" data-id="element-1302">
            Cancel
          </Button>
          <Button onClick={onConfirm} className="flex-1" size="sm" data-id="element-1303">
            Confirm ({creditsNeeded}{' '}
            {creditsNeeded === 1 ? 'credit' : 'credits'})
          </Button>
        </div>
      </div>
    </div>;
}